import {useBaseQuery, useBaseMutation, useInvalidateQueries} from './useBaseQuery.ts';
import {ttsApi} from '../api/ttsApi.ts';
import {PaginationData} from '../models/paginationData.ts';
import {TtsDashboard, TtsAudioItem} from '../types/tts.ts';
import NoDataResponse from '../models/noDataResponse.ts';

export const ttsKeys = {
    all: ['tts'] as const,
    dashboard: () => [...ttsKeys.all, 'dashboard'] as const,
    audio: () => [...ttsKeys.all, 'audio'] as const,
};

export const useTtsDashboard = () => {
    return useBaseQuery<TtsDashboard>(
        ttsKeys.dashboard(),
        () => ttsApi.getDashboard(),
        {staleTime: 10_000},
    );
};

export const useTtsAudioList = (page: number, size: number, lang?: string, search?: string) => {
    return useBaseQuery<PaginationData<TtsAudioItem>>(
        [...ttsKeys.audio(), page, size, lang, search],
        () => ttsApi.getAudioList(page, size, lang, search),
        {staleTime: 5_000},
    );
};

export const useTtsRegenerateAudio = () => {
    const {invalidateMultiple} = useInvalidateQueries();
    return useBaseMutation<{id: number}, NoDataResponse>(
        ({id}) => ttsApi.regenerateAudio(id),
        {
            onSuccess: () => {
                invalidateMultiple([ttsKeys.audio(), ttsKeys.dashboard()]);
            },
        },
    );
};
